import { render, staticRenderFns } from "./CQFooter.vue?vue&type=template&id=98cfd1e8&scoped=true&"
import script from "./CQFooter.vue?vue&type=script&lang=js&"
export * from "./CQFooter.vue?vue&type=script&lang=js&"
import style0 from "./CQFooter.vue?vue&type=style&index=0&id=98cfd1e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cfd1e8",
  null
  
)

export default component.exports